import { axiosBasic } from "../config/axios-common";

const postInsertLog = async (professionalId: string, logMessage: string, info: boolean, error: boolean) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }

        const data = {
            logMessage: logMessage, 
            info: info,
            error: error    
        }

        const response = await axiosBasic.post(`/sam/v1/logs/insert?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

 

const exportedObject = {
    postInsertLog    
};


export default exportedObject